import type { ReactNode } from 'react';

export const symbol_hdr_strong: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M185-330q-61 0-103-42T40-475q0-62 42-103.5T185-620q62 0 103.5 41.5T330-475q0 61-41.5 103T185-330Zm62-83q23-23 23-62t-23-62q-23-23-62-23t-62 23q-23 23-23 62t23 62q23 23 62 23t62-23Zm263.5 102.5Q440-381 440-480t70.5-169.5Q581-720 680-720t169.5 70.5Q920-579 920-480t-70.5 169.5Q779-240 680-240t-169.5-70.5Z"
		/>
	</svg>
);
